export default __webpack_public_path__ + "static/journey-beginning-5fb300fbf20d6db1031d529fccb88187.jpg";